// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-wrap {
  display: flex;
}

.table-row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}

.objects-wrap {
  display: flex;
  flex-direction: column;
}

.object-def {
  margin: 10px 0;
}

.objects-actions {
  display: flex;
  margin: 12px 0;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
}
.objects-actions .btn {
  margin-bottom: 0;
  position: relative;
  font-size: 1.5rem;
  color: var(--grey-icon);
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
}
.objects-actions .btn:is(:disabled) {
  opacity: 0;
}
.objects-actions .btn .title {
  display: none;
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: var(--white);
  white-space: nowrap;
  background: var(--grey-icon);
  padding: 0.5rem 1rem;
  border-radius: 0.4rem;
  position: absolute;
  bottom: 0.2rem;
  z-index: 2;
  left: 50%;
  transform: translate(-50%, 100%);
}
.objects-actions .btn:hover:is(:not(:disabled)) {
  color: var(--primary);
}
.objects-actions .btn:hover:is(:not(:disabled)) .title {
  display: block;
}
.objects-actions .search-table {
  width: 40%;
}
.objects-actions .search-table .app-form-field .error {
  height: auto;
}

.button {
  -webkit-user-select: none;
          user-select: none;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  display: flex;
  align-items: center;
  margin-bottom: 21px;
}
.button:disabled {
  cursor: none;
  pointer-events: none;
}
.button:hover {
  color: var(--primary);
}

.disabled {
  pointer-events: none;
  z-index: -1;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0.5;
  color: var(--grey-border);
  /* for "disabled" effect */
  opacity: 0.5;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}
.pagination .btn {
  width: 2.4rem;
  height: 2.4rem;
  font-size: 1.2rem;
  color: var(--grey);
  border: 0.1rem solid var(--grey-variable-hover);
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s;
}
.pagination .btn:hover {
  border-color: var(--primary-30);
}
.pagination .btn:active {
  border-color: var(--primary);
}
.pagination .btn:disabled {
  border: 0.1rem solid var(--grey-variable-hover);
  opacity: 0.5;
  cursor: default;
}
.pagination .btn.prev {
  transform: rotateZ(90deg);
}
.pagination .btn.next {
  transform: rotateZ(-90deg);
}
.pagination .current {
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: var(--grey-icon);
}`, "",{"version":3,"sources":["webpack://./src/shared/dynamic-table/dynamic-table/dynamic-table.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,qCAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,cAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAAF;AAEE;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAAJ;AAEI;EACE,UAAA;AAAN;AAGI;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,gCAAA;AADN;AAII;EACE,qBAAA;AAFN;AAIM;EACE,cAAA;AAFR;AAOE;EACE,UAAA;AALJ;AAOI;EACE,YAAA;AALN;;AAUA;EACE,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAPF;AASE;EACE,YAAA;EACA,oBAAA;AAPJ;AAUE;EACE,qBAAA;AARJ;;AAYA;EACE,oBAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,0BAAA;EACA,YAAA;AATF;;AAYA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AATF;AAWE;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,+CAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AATJ;AAWI;EACE,+BAAA;AATN;AAYI;EACE,4BAAA;AAVN;AAaI;EACE,+CAAA;EACA,YAAA;EACA,eAAA;AAXN;AAcI;EACE,yBAAA;AAZN;AAeI;EACE,0BAAA;AAbN;AAiBE;EACE,iBAAA;EACA,mBAAA;EACA,uBAAA;AAfJ","sourcesContent":[".table-wrap {\n  display: flex;\n}\n\n.table-row {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n}\n\n.objects-wrap {\n  display: flex;\n  flex-direction: column;\n  // gap: 20px;\n}\n\n.object-def {\n  margin: 10px 0;\n}\n\n.objects-actions {\n  display: flex;\n  margin: 12px 0;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: center;\n\n  .btn {\n    margin-bottom: 0;\n    position: relative;\n    font-size: 1.5rem;\n    color: var(--grey-icon);\n    border-radius: 0.4rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: 0.3s;\n\n    &:is(:disabled) {\n      opacity: 0;\n    }\n\n    & .title {\n      display: none;\n      font-size: 1.2rem;\n      line-height: 1.4rem;\n      color: var(--white);\n      white-space: nowrap;\n      background: var(--grey-icon);\n      padding: 0.5rem 1rem;\n      border-radius: 0.4rem;\n      position: absolute;\n      bottom: 0.2rem;\n      z-index: 2;\n      left: 50%;\n      transform: translate(-50%, 100%);\n    }\n\n    &:hover:is(:not(:disabled)) {\n      color: var(--primary);\n\n      & .title {\n        display: block;\n      }\n    }\n  }\n\n  .search-table {\n    width: 40%;\n\n    .app-form-field .error {\n      height: auto;\n    }\n  }\n}\n\n.button {\n  user-select: none;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 120%;\n  display: flex;\n  align-items: center;\n  margin-bottom: 21px;\n\n  &:disabled {\n    cursor: none;\n    pointer-events: none;\n  }\n\n  &:hover {\n    color: var(--primary);\n  }\n}\n\n.disabled {\n  pointer-events: none;\n  z-index: -1;\n  user-select: none;\n  opacity: 0.5;\n  color: var(--grey-border);\n  /* for \"disabled\" effect */\n  opacity: 0.5;\n}\n\n.pagination {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 1rem;\n\n  & .btn {\n    width: 2.4rem;\n    height: 2.4rem;\n    font-size: 1.2rem;\n    color: var(--grey);\n    border: 0.1rem solid var(--grey-variable-hover);\n    border-radius: 0.2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: border-color 0.2s;\n\n    &:hover {\n      border-color: var(--primary-30);\n    }\n\n    &:active {\n      border-color: var(--primary);\n    }\n\n    &:disabled {\n      border: 0.1rem solid var(--grey-variable-hover);\n      opacity: 0.5;\n      cursor: default;\n    }\n\n    &.prev {\n      transform: rotateZ(90deg);\n    }\n\n    &.next {\n      transform: rotateZ(-90deg);\n    }\n  }\n\n  & .current {\n    font-size: 1.2rem;\n    line-height: 1.4rem;\n    color: var(--grey-icon);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
